var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.567,
    height: 19.55,
    viewBox: "6.983 6.983 19.567 19.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.024 9.827a1.71 1.71 0 0 1 0 2.414l-2.36 2.361-3.938-3.937-9.227 9.227 3.132 3.132 8.153-8.152.805.805-9.661 9.66L7 26.523l1.186-5.928L18.921 9.86l2.36-2.36a1.71 1.71 0 0 1 2.415 0l2.328 2.327Zm-16.33 10.87-.458.458-.783 3.915 3.914-.783.46-.459-3.132-3.131Zm9.962-7.634.804.805-7.039 7.04-.805-.806 7.04-7.04Zm2.833-4.926a.566.566 0 0 0-.402.167L20.53 9.86l3.132 3.132 1.556-1.556a.572.572 0 0 0 0-.804l-2.328-2.328a.565.565 0 0 0-.402-.167Z",
    fill: "#333",
    fillRule: "evenodd",
    "data-name": "Path 40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.901f2cdca4f8a9e95d32797464e0c9be.svg";
export { ForwardRef as ReactComponent };